import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'

import { Form } from '../../Form/index.js'

export const SelectInput = ({
  field,
  name,
  onChange,
  value,
  extraProps,
  enumValidator,
}) => {
  try {
    const validValues = JSON.parse(enumValidator.value)
    const labels = field?.labels ?? {}

    if (extraProps?.label) {
      return (
        <Form.Select
          name={name}
          items={validValues?.map(value => ({
            text: labels[value] ?? (value || '-'),
            value,
          }))}
          onChange={value => {
            if (typeof onChange === 'function') {
              onChange(value)
            }
          }}
          {...extraProps}
        />
      )
    }

    return (
      <Dropdown>
        <Dropdown.Button>{labels[value] ?? value}</Dropdown.Button>
        <Dropdown.Items>
          {validValues.map(value => (
            <Dropdown.Item
              key={name}
              onClick={() => {
                if (typeof onChange === 'function') {
                  onChange(value)
                }
              }}
            >
              {labels[value] ?? value}
            </Dropdown.Item>
          ))}
        </Dropdown.Items>
      </Dropdown>
    )
  } catch (e) {
    console.error('Could not parse enum custom field validator')
  }
  return null
}
